import {ClientCallType} from '@pexip/infinity';

import {CALL_TYPE} from '../constants';

export const toClientCallType = (callType: string): ClientCallType => {
    switch (callType) {
        case 'none': {
            return ClientCallType.None;
        }
        case 'presentation-only': {
            return ClientCallType.Presentation;
        }
        case 'audioonly': {
            return ClientCallType.AudioPresentation;
        }
        case 'audiorecvonly': {
            return ClientCallType.AudioRecvOnlyPresentation;
        }
        case 'audiosendonly': {
            return ClientCallType.AudioSendOnlyPresentation;
        }
        case 'videoonly': {
            return ClientCallType.VideoPresentation;
        }
        case 'videorecvonly': {
            return ClientCallType.VideoRecvOnlyPresentation;
        }
        case 'videosendonly': {
            return ClientCallType.VideoSendOnlyPresentation;
        }
        case 'audiovideosendonly': {
            return ClientCallType.AudioSendVideoSendOnlyPresentation;
        }
        case 'audiovideorecvonly': {
            return ClientCallType.AudioRecvVideoRecvOnlyPresentation;
        }
        case 'video': {
            return ClientCallType.AudioVideoPresentation;
        }
        default: {
            return CALL_TYPE;
        }
    }
};
